import { SOURCE_TYPE } from '@/types/feedbackConst';

import { NaverCafeSourceGuide } from './NaverCafeSourceGuide';
import { ProductInfoGuide } from './ProductInfoGuide';

export const GuideBannerBySource = (props: { sourceType: SOURCE_TYPE }) => {
  const { sourceType } = props;

  const GuideBanner = () => {
    switch (sourceType) {
      case SOURCE_TYPE.NAVER_CAFE:
        return <NaverCafeSourceGuide />;
      case SOURCE_TYPE.AMAZON:
      case SOURCE_TYPE.COUPANG:
      case SOURCE_TYPE.SEPHORA:
      case SOURCE_TYPE.QOO10:
      case SOURCE_TYPE.NAVER_STORE:
      case SOURCE_TYPE.OLIVEYOUNG:
      case SOURCE_TYPE.THRIVE_MARKET:
      case SOURCE_TYPE.LAZADA:
      case SOURCE_TYPE.SHOPEE:
        return <ProductInfoGuide />;
      default:
        return null;
    }
  };

  if (!GuideBanner) return null;

  return (
    <div className="ml-35 mb-4">
      <GuideBanner />
    </div>
  );
};
